module.exports = __webpack_public_path__ + "static/img/202503011026211.046bfaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/202503011026211.png
// module id = 6b7p
// module chunks = 1